module.exports = __webpack_public_path__ + "img/news-04_2x.503c7b03.png";